module.exports = __webpack_public_path__ + "img/horizontal_3_7_8003.16b1e992.png";